import { render, staticRenderFns } from "./CompaniesCreate.vue?vue&type=template&id=dcf732ac&scoped=true&"
import script from "./CompaniesCreate.vue?vue&type=script&lang=js&"
export * from "./CompaniesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf732ac",
  null
  
)

export default component.exports